<template>
  <div class="w-full text-3xl text-center text-red-800 mb-4">
    <a href="https://github.com/huss-a/covid-tracker" class="mx-2" target="_blank">
      <i class="fab fa-github" />
    </a>
    <!-- <a class="mx-2" href="https://twitter.com/reactsimp" target="_blank">
      <i class="fab fa-twitter" />
    </a> -->
  </div>
</template>
